enum LocalStorageKey {
  BENEFITS_OVERVIEW = 'BENEFITS_OVERVIEW',
}

export default LocalStorageKey;
